import {Box, Drawer} from '@mui/material';
import {useTranslation} from '../i18n/hooks/useTranslation';
import {useLayoutOffset} from '../layout/hooks/useLayoutOffset';
import {PublicNavigationMenu} from '../layout/public/PublicNavigationMenu';
import {ComponentWithoutChildren} from '../react/types';

interface PublicSideNavigationProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PublicSideNavigation: ComponentWithoutChildren<PublicSideNavigationProps> = ({
  isOpen,
  onClose,
}: PublicSideNavigationProps) => {
  const {verticalOffset} = useLayoutOffset();
  const {translate} = useTranslation('main');
  return (
    <Box aria-label={translate('main:sideNavigation')} component="nav" role="navigation">
      <Drawer
        ModalProps={{
          keepMounted: true, // Better open performance on mobile
        }}
        data-testid="PublicSideNavigation"
        onClose={onClose}
        open={isOpen}
        variant={'temporary'}
      >
        <PublicNavigationMenu orientation="horizontal" sx={{mt: `${verticalOffset}px`}} />
      </Drawer>
    </Box>
  );
};
